import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'detailKondolenzen',
  pure: false
})
export class DetailKondolenzenPipe implements PipeTransform {
    transform(items: Array<any>, category: string): any[] {
        if (!items) {return []; }
        if (!category) {return items; }
        category = category.toString().toLowerCase();
        return items.filter(item => item.art === category);
    }
}
